import * as React from 'react';

export interface TestPageProps {
	match: any;
}

export interface TestStateState {
}

export class TestPage extends React.Component<TestPageProps, TestStateState>  {

	constructor(props: TestPageProps) {
		super(props);
	}

	render(): React.ReactNode {
		return (
			<div style={{textAlign: "center"}}>
				<h1>Test page {this.props.match.params.id}</h1>
			</div>
		);
	}
}
